import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import qs from "qs";
import { API_HOST } from "../config";

const server = axios.create({
  baseURL: API_HOST,
  headers: {
    common: {
      ContentType: "application/json",
    },
  },
});

const appendJWT = (request: AxiosRequestConfig) => {
  const newRequest = request;
  const jwt = localStorage.getItem("jwt");
  if (jwt) newRequest.headers.Authorization = `Bearer ${jwt}`;
  return newRequest;
};
const handleResponse = (response: AxiosResponse) => response;
const handleError = (error: { response: AxiosResponse }) => error.response;

server.defaults.paramsSerializer = (params) => qs.stringify(params, { encode: false });
server.interceptors.response.use(handleResponse, handleError);
server.interceptors.request.use(appendJWT);

export default server;
